@if (measurement(); as m) {
  <cosmos-measurement-info-card
    [measurement]="m"
    [device]="device()"
    [cardSubtitle]="('measurement.types.' + m.measurementType | translate) + ' - ' + ('measurement.status.never-started' | translate)"
  >
    <ng-container cardFooter>
      <div class="flex flex-wrap gap-2 items-center">
        @if (rbac.canEditProject()) {
          <p-button (click)="editMeasurement()" color="primary"><i class="fa-solid fa-edit"></i> {{ "measurement.edit" | translate }}</p-button>
        }
        @if (rbac.canEditProject()) {
          <p-button (click)="openRescheduleDialog()" severity="secondary"><i class="fa-solid fa-clock-rotate-left"></i>{{ 'measurement.never-started.reschedule-button' | translate }}</p-button>
        }
        @if (rbac.canEditProject()) {
          <p-button (click)="moveStage()" severity="secondary"><i class="fa-solid fa-layer-group"></i>{{ "measurement.move_stage.action" | translate }}</p-button>
        }
      </div>
    </ng-container>
  </cosmos-measurement-info-card>
}

<p-card class="mt-4" id="onboarding-measurement-never-started-card">
  <ng-template #title>{{ 'measurement.never-started.card-title' | translate }}</ng-template>
  <ng-template #subtitle>{{ 'measurement.never-started.subtitle' | translate }}</ng-template>

  <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-list-ol"></i></div>
      <div class="item-text">
        <div class="item-title">{{ pointCount() }}</div>
        <div class="item-line">{{ 'measurement.awaiting-start.point-count' | translate }}</div>
      </div>
    </div>
    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-hourglass-start"></i></div>
      <div class="item-text">
        <div class="item-title">{{ firstTimestamp() ? (firstTimestamp() | date:'dd/MM/yyyy HH:mm') : '-' }}</div>
        <div class="item-line">{{ 'measurement.awaiting-start.first-timestamp' | translate }}</div>
      </div>
    </div>
    <div class="card-list-item">
      <div class="card-list-item-icon"><i class="fa-solid fa-hourglass-end"></i></div>
      <div class="item-text">
        <div class="item-title">{{ lastTimestamp() ? (lastTimestamp() | date:'dd/MM/yyyy HH:mm') : '-' }}</div>
        <div class="item-line">{{ 'measurement.awaiting-start.last-timestamp' | translate }}</div>
      </div>
    </div>
  </div>
</p-card>
